import React, { forwardRef } from 'react';
import { Form as FormUI } from '@ui-framework/index';
import * as Dialogs from '../Dialogs/index';
import * as FormFields from '../FormFields/index';

const Form = forwardRef((props, ref) => {
  const { customComponents, ...rest } = props;
  return (
    <FormUI
      ref={ref}
      customComponents={{
        ...(customComponents || {}),
        ...FormFields,
      }}
      dialogs={Dialogs}
      {...rest}>
      {props?.children}
    </FormUI>
  );
});

export default Form;
